<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.toc-offers") }}</h4>
            </div>
            <div class="card-body px-3">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary mr-5" >{{$t('message.back')}}</router-link> -->
              <button @click="show_new" class="btn btn-success btn-sm ml-5">
                {{ $t("message.add") }}
              </button>
              <b-table
                :items="offers"
                :fields="offer_fields"
                :per-page="per_page"
                :current-page="current_page"
              >
                <template v-slot:cell(offer_file)="data">
                  <a
                    :href="data.value"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ $t("message.admin.download") }}</a
                  >
                </template>
                <template v-slot:cell(offer_diff)="data">
                  <a
                    :href="data.value"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ $t("message.admin.download") }}</a
                  >
                </template>
                <template v-slot:cell(start_date)="data">
                  {{ momentum(data.value) }}
                </template>
                <template v-slot:cell(end_date)="data">
                  <span v-if="data.value != null && data.value != ''">
                    {{ momentum(data.value) }}
                  </span>
                </template>
                <template v-slot:cell(status)="data">
                  <span
                    v-if="
                      data.item.end_date == null || data.item.end_date == ''
                    "
                  >
                    {{ $t("message.admin.toc-offer-active") }}
                  </span>
                  <span v-else>
                    {{ $t("message.admin.toc-offer-inactive") }}
                  </span>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="offers_length"
                  :per-page="per_page"
                  aria-controls="my-offers-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-add-new-toc"
      :hide-footer="true"
      size="sm"
      :title="$t('message.admin.toc-offers')"
      button-size="lg"
    >
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.offer_file") }}
        </label>
        <input
          type="file"
          @change="attachFile($event, 'offer_file')"
          id="offer_file"
          class="form-control"
        />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_diff">
          {{ $t("message.admin.offer_diff") }}
        </label>
        <input
          type="file"
          @change="attachFile($event, 'offer_diff')"
          id="offer_diff"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label for="offer_start_date">
          {{ $t("message.admin.offer_start_date") }}
        </label>
        <datepicker
          @focus="start_date = ' '"
          value-type="YYYY-MM-DD"
          format="DD.MM.YYYY"
          @blur="
            start_date == ' ' ? (start_date = '') : (start_date = start_date)
          "
          inputClass="form-control"
          :disabled="is_field_readonly"
          v-model="start_date"
          :placeholder="$t('message.admin.offer_start_date')"
          :inputAttr="{ id: 'offer_start_date' }"
        />
        <!-- <b-form-datepicker :locale="locale" v-model="start_date" :placeholder="$t('message.admin.offer_start_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="offer_start_date"></b-form-datepicker> -->
      </div>
      <div class="text-center">
        <button @click="add_new_offer" class="btn btn-success btn-sm">
          {{ $t("message.add") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "admin-toc-offers",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    offers_length() {
      return this.offers.length;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  data() {
    return {
      current_page: 0,
      per_page: 20,
      offers: [],
      add_offer: false,

      offer_file: "",
      offer_diff: "",
      start_date: "",

      offer_fields: [
        {
          key: "offer_file",
          label: this.$t("message.admin.offer_file"),
        },
        {
          key: "offer_diff",
          label: this.$t("message.admin.offer_diff"),
        },
        {
          key: "start_date",
          label: this.$t("message.admin.offer_start_date"),
        },
        {
          key: "end_date",
          label: this.$t("message.admin.offer_end_date"),
        },
        {
          key: "status",
          label: this.$t("message.admin.offer_status"),
        },
      ],
    };
  },
  methods: {
    attachFile(event, u) {
      if (typeof event.target.files[0] !== "undefined")
        if (u == "offer_file") this.offer_file = event.target.files[0];
      if (u == "offer_diff") this.offer_diff = event.target.files[0];
    },
    add_new_offer() {
      let fd = new FormData();
      fd.append("offer_file", this.offer_file);
      fd.append("offer_diff", this.offer_diff);
      fd.append("start_date", this.start_date);
      axios
        .post(window.base + "/admin/offer_upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.$bvModal.hide("modal-add-new-toc");
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.message.select-delivery_offer-ok"),
            timeout: 5000,
          }).show();
        })
        .catch(() => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.decline_delivery_offer-nok"),
            timeout: 5000,
          }).show();
        });
    },
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    /**
     * Fetches list of all offers
     */
    load() {
      axios.get(window.base + "/admin/offers").then((response) => {
        this.offers = response.data; //.filter(i=>i.active==1)
      });
    },
    show_new() {
      this.$bvModal.show("modal-add-new-toc");
    },
  },
};
</script>
<style>
.page-item.active button {
  /* background: #9c27b0 !important; */
  /* color: #fff !important; */
}
</style>
